import React from 'react'
import Workspace from "components/Workspace";
import NationalNoticePage from "components/complex/nationalNotice/NationalNoticePage";

function NationalNoticePanel(
    {
        match
    }) {

    const demandId = match.params.id;
    const formType = match.params.formType;

    return (
        <>
            <Workspace
                render={<>
                    <NationalNoticePage demandId={demandId} formType={formType} />
                </>}
            />
        </>
    )
}


export default NationalNoticePanel;